import { render, staticRenderFns } from "./AccountSupport.vue?vue&type=template&id=2b52e06c&scoped=true"
import script from "./AccountSupport.vue?vue&type=script&lang=js"
export * from "./AccountSupport.vue?vue&type=script&lang=js"
import style0 from "./AccountSupport.vue?vue&type=style&index=0&id=2b52e06c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52e06c",
  null
  
)

export default component.exports